import { FilterContentTypes, } from '@as-react/common-types';
import { createSelector } from 'reselect';
import { FilterActionTypes } from './../../../enums/ActionEnums';
const FILTER_ON_BRAND = 'brand';
const getProductSearchInformation = (state) => state.lister;
const getTotalPages = (state) => state.lister.totalPages;
export const makeGetProductSearchInformationState = () => createSelector([getProductSearchInformation], (lister) => lister);
export const makeGetListerHeadingInformation = () => createSelector([getProductSearchInformation], (lister) => ({
    itemCount: lister.itemCount,
    title: lister.title,
}));
export const makeGetItemCount = () => createSelector([getProductSearchInformation], (lister) => lister.itemCount);
export const makeGetSeoTextInformation = () => createSelector([getProductSearchInformation], (lister) => lister.seoTextInclude);
export const makeGetHideTitle = () => createSelector([getProductSearchInformation], (lister) => lister.hideTitle);
const getFilters = (state) => {
    return state.lister.filters;
};
const getExecutionStatus = (state) => {
    return state.lister.executionStatus;
};
const getAlternativeQueryResults = (state) => {
    return state.lister.alternativeQueryResults;
};
const getProductGroupUniqueIds = (state) => {
    return state.lister.productGroupUniqueIds;
};
const getPartialSearchResults = (state) => {
    return state.lister.partialSearchResults;
};
export const makeGetFiltersState = (isBrandPage) => createSelector([getFilters], (filters) => isBrandPage ? filters.filter((filter) => filter.filterOn !== FILTER_ON_BRAND) : filters);
export const makeGetExecutionStatus = () => createSelector([getExecutionStatus], (executionStatus) => executionStatus);
export const makeGetAlternativeQueryResults = () => createSelector([getAlternativeQueryResults], (alternativeQueryResults) => alternativeQueryResults);
export const makeGetProductGroupUniqueIds = () => createSelector([getProductGroupUniqueIds], (productGroupUniqueIds) => productGroupUniqueIds);
export const makeGetPartialSearchResults = () => createSelector([getPartialSearchResults], (partialSearchResults) => partialSearchResults);
export const makeGetEnabledFiltersState = (isBrandPage) => createSelector([getFilters], (filters) => filters.filter((filter) => isBrandPage
    ? !filter.disabled && filter.filterOn !== FILTER_ON_BRAND && filter.type !== FilterActionTypes.UNHANDLED_FILTER
    : !filter.disabled && filter.type !== FilterActionTypes.UNHANDLED_FILTER));
const getActiveFilters = (state) => state.filters.activeFilters;
const getQuickLinks = (state) => state.lister.quickLinks;
const getContentBlocks = (state) => state.lister.contentBlocks;
export const makeGetActiveFiltersState = () => createSelector([getActiveFilters], (activeFilters) => activeFilters);
export const makeGetQuickLinks = () => createSelector([getQuickLinks], (quickLinks) => quickLinks.filter(quickLink => !!quickLink.linkPath && !!quickLink.linkName));
export const makeGetContentBlocks = () => createSelector([getContentBlocks], (contentBlocks) => contentBlocks.filter(contentBlock => !!contentBlock.linkPath && !!contentBlock.visibleInRow && !!contentBlock.content));
export const makeGetFlattenedActiveFiltersState = () => createSelector([getActiveFilters], (activeFilters) => {
    return (!!activeFilters &&
        Object.keys(activeFilters).reduce((arr, filterOn) => {
            const activeFilter = activeFilters[filterOn];
            let result = [];
            if ((activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.filterType) === FilterActionTypes.RANGE_FILTER) {
                result = [
                    {
                        filterContentType: activeFilter.filterContentType,
                        filterOn: filterOn,
                        filterOnName: activeFilter.filterOnName,
                        filterType: activeFilter.filterType,
                        filterPrefix: activeFilter.filterPrefix,
                        filterSuffix: activeFilter.filterSuffix,
                        rangeMin: activeFilter.rangeMin,
                        rangeMax: activeFilter.rangeMax,
                    },
                ];
            }
            else {
                if (activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.values) {
                    result = activeFilter.values.map(activeFilterValue => ({
                        filterContentType: activeFilter.filterContentType,
                        filterKey: activeFilterValue.filterKey,
                        filterKeyName: activeFilterValue.filterKeyName,
                        filterOn: filterOn,
                        filterType: activeFilter.filterType,
                        filterOnName: activeFilter.filterOnName,
                    }));
                }
            }
            return arr.concat(result);
        }, [])) || [];
});
export const makeGetSingleActiveSizeFilterKeyName = () => createSelector([getActiveFilters], (activeFilters) => {
    var _a, _b, _c;
    if (!activeFilters) {
        return undefined;
    }
    const activeSizeFiltersKey = Object.keys(activeFilters).filter(activeFilterKey => {
        var _a, _b, _c;
        return ((_a = activeFilters[activeFilterKey]) === null || _a === void 0 ? void 0 : _a.filterContentType) === FilterContentTypes.SIZE &&
            ((_c = (_b = activeFilters[activeFilterKey]) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.length);
    });
    return activeSizeFiltersKey[0] ? (_c = (_b = (_a = activeFilters[activeSizeFiltersKey[0]]) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.filterKeyName : undefined;
});
const getLoadingState = (state) => state.lister.isLoading;
const getCategoryHierarchyTree = (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.lister) === null || _a === void 0 ? void 0 : _a.categoryHierarchyTree; };
export const makeGetLoadingState = () => createSelector([getLoadingState], isLoading => isLoading);
export const makeGetTotalPages = () => createSelector([getTotalPages], totalPages => totalPages);
export const makeGetfredhopperGlossaryState = () => createSelector([getProductSearchInformation], (lister) => {
    var _a;
    const fredhopperGlossary = {};
    (_a = lister.fredhopperGlossary) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        item.triggers.forEach(trigger => {
            trigger.indexOf('fh_') !== -1 &&
                (fredhopperGlossary[trigger] = {
                    description: item.description,
                    title: item.title,
                });
        });
    });
    return fredhopperGlossary;
});
export const makeGetFilterWizardState = () => createSelector([getProductSearchInformation], (lister) => lister.filterWizard);
export const makeGetInStoreFilterState = () => createSelector([getProductSearchInformation], (lister) => lister.inStoreFilter);
export const makeGetFredhopperSegment = () => createSelector([getProductSearchInformation], (lister) => lister.segment);
export const makeGetIsCSR = () => createSelector([getProductSearchInformation], (lister) => lister.isCSR);
export const makeGetListerItems = () => createSelector([getProductSearchInformation], (lister) => lister.items);
export const makeGetIsLoaded = () => createSelector([getProductSearchInformation], (lister) => lister.isLoaded);
export const makeGetEnableJsonLd = () => createSelector([getProductSearchInformation], (lister) => lister.enableJsonLd);
export const makeGetParentPage = () => createSelector([getProductSearchInformation], (lister) => lister.parentPage);
export const makeGetCategoryHierarchyTree = () => createSelector([getCategoryHierarchyTree], (categoryHierarchyTree) => categoryHierarchyTree);
